import React from "react";
import { Route, IndexRoute } from "react-router";

import Home from "./containers/Home";

function isClient() {
  return typeof window != "undefined" && window.document;
}

function getCookie(cookie, key) {
  let arr = cookie.match(new RegExp("(^| )" + key + "=([^;]*)(;|$)"));
  if (arr != null) return unescape(arr[2]);
  return null;
}


export default (
  <Route path="/">
    {/*<IndexRoute component={Home} /> */}
{/* ----------------------------------- */}
    <Route path="/" component={Home}/>
    <IndexRoute getComponent={(location, callback) =>
        require.ensure([], (require) =>
          callback(null, require("./containers/Home").default),
        )
      } />
    <Route
      path="/content/*"
      getComponent={(location, callback) =>
        require.ensure([], (require) => callback(null, require("./containers/Content").default))
      }
    />
     <Route
      path="/v2/html/contact.html"
      getComponent={(location, callback) =>
        require.ensure([], (require) =>
          callback(null, require("./containers/ContactBrand").default),
        )
      }
    />
    <Route
      path="/campaign/:id"
      getComponent={(location, callback) =>
        require.ensure([], (require) => callback(null, require("./containers/Campaign").default))
      }
    />
    <Route
      path="/error"
      getComponent={(location, callback) =>
        require.ensure([], (require) => callback(null, require("./containers/404").default))
      }
    />
    <Route
      path="/resetPasswords"
      getComponent={(location, callback) =>
        require.ensure([], (require) =>
          callback(null, require("./containers/CreateNewPassword").default),
        )
      }
    />
    {/* 隐私设置 */}
    <Route
      path="*"
      getComponent={(location, callback) =>
        require.ensure([], (require) => callback(null, require("./containers/404").default))
      }
    />
  </Route>
);



// WEBPACK FOOTER //
// ./common/routes.js